// external
import React from "react";
import { PropTypes } from "prop-types";
import { useDropArea } from "react-use";
import { withTranslation } from "react-i18next";

// internal
import "css/admin/utils/upload-button.scss";

function UploadButton({
  percentProgress,
  uploadComplete,
  uploadStart,
  btnLabel,
  upload,
  icon,
  t,
}) {
  const [bond] = useDropArea({
    onFiles: (files) => upload(files[0]),
  });

  const onSelectFile = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    upload(file);
  };

  // permet d'afficher le message "Upload en cours" même si le pourcentage de progression n'est pas encore à 0 (ex: lors de l'upload d'un fichier de petite taille)
  // uploadStart = true;

  // percentProgress = 10;

  const queuedUpload = uploadStart && percentProgress === 0;

  return (
    <div className="upload-button-container" {...bond}>
      {queuedUpload && (
        <div className="upload-button-queued">{t("queuedUpload")}</div>
      )}
      <label
        htmlFor="upload-button-input"
        className={`upload-button ${uploadStart ? "upload-button-progress" : ""} ${uploadComplete ? "upload-button-complete" : ""}`}
      >
        <a className="upload-button-link">
          <div className="upload-button-label">
            {icon && <i className="material-icons">{icon}</i>}
            <span>{btnLabel}</span>
          </div>
          <svg
            className="load"
            version="1.1"
            x="0px"
            y="0px"
            width="30px"
            height="30px"
            viewBox="0 0 40 40"
            enableBackground="new 0 0 40 40"
          >
            <path
              opacity="0.3"
              fill="#fff"
              d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
              s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
              c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
            />
            <path
              fill="#fff"
              d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
              C22.32,8.481,24.301,9.057,26.013,10.047z"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 20 20"
                to="360 20 20"
                dur="0.5s"
                repeatCount="indefinite"
              />
            </path>
          </svg>
          <svg
            className="check"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
          </svg>
        </a>
        <div className="loadBar-container">
          <span className="loadBar" style={{ width: `${percentProgress}%` }} />
        </div>
        <input
          id="upload-button-input"
          className="upload-button-input"
          type="file"
          disabled={percentProgress || !upload}
          onChange={upload ? onSelectFile : null}
        />
      </label>
    </div>
  );
}

UploadButton.propTypes = {
  t: PropTypes.func.isRequired,
  upload: PropTypes.func,
  percentProgress: PropTypes.number,
  uploadComplete: PropTypes.bool,
  uploadStart: PropTypes.bool,
  btnLabel: PropTypes.string,
  icon: PropTypes.string,
};

export default withTranslation("editor-content")(UploadButton);
